module.exports = __webpack_public_path__ + "img/parlophone-nma.0ea0912c.jpg";